import React from 'react'
import { ADMIN_PANEL, STAFF_BENEFIT_ADMIN, COMPANY_MAPPING_ADMIN } from '../../constant/permission'
import PeopleIcon from '@mui/icons-material/People'
import LoyaltyIcon from '@mui/icons-material/Loyalty'
import RateReviewIcon from '@mui/icons-material/RateReview'
import BusinessIcon from '@mui/icons-material/Business'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'

export const MENU = [
  {
    url: '/admin',
    icon: <PeopleIcon fontSize='small' />,
    text: 'Users',
    permission: ADMIN_PANEL,
  },
  {
    url: '/staff-benefit',
    icon: <LoyaltyIcon fontSize='small' />,
    text: 'Staff Benefit',
    permission: STAFF_BENEFIT_ADMIN,
  },
  {
    url: '/claims-review',
    icon: <RateReviewIcon fontSize='small' />,
    text: 'Staff Benefit Claims',
    permission: STAFF_BENEFIT_ADMIN,
  },
  // {
  //   url: '/company-mapping',
  //   icon: <BusinessIcon fontSize='small' />,
  //   text: 'Company Mapping',
  //   permission: COMPANY_MAPPING_ADMIN,
  // },
  {
    url: '/whatsapp-config',
    icon: <WhatsAppIcon fontSize='small' />,
    text: 'Whatsapp Config',
    permission: ADMIN_PANEL,
  },
]
